import * as t from 'io-ts';
import { Authentication } from 'acscp/api/requests/core/baseRequest';
import { BasePostRequest } from 'acscp/api/requests/core/basePostRequest';
import { FlightRequest } from 'acscp/api/models/flightRequest';

export class CreateFlightRequestRequest extends BasePostRequest<undefined> {
    constructor(enquiry: FlightRequest) {
        super(`flight-requests`, {}, enquiry, t.undefined, Authentication.Login);
    }
}
